<template>
  <transition name='fade'>
    <div
      class="modal headimg_box"
      v-if='visible'
    >
      <div
        class="headimg"
        style="height:80%;"
      >
        <div class="title msp_icon_close">
          <span class="title_name">调整图片顺序</span>
          <span
            class="title_name"
            style="color:#fd4a4a;margin-left:12px;"
          >(拖动调整顺序)</span>
          <span
            class="iconfont el-icon-close"
            @click.stop='closeBox()'
          ></span>
        </div>
        <div class="watermark">
          <div class="watermark_right">
            <div
              class="each_water_image each_listcontent_img"
              v-for="(item,index) in listImg"
              :key="index"
            >
              <el-image
                style="width: 120px; height: 120px"
                :src="item.url"
                :alt='alt'
                :fit="fit"
                class="el-image-class"
              >
                <div
                  slot="error"
                  class="image-slot"
                >
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div
                class="preview_img"
                @click="previewCurrentImg(item)"
              >
                <span class="iconfont icon-yulan1"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="headimg_buttom">
          <el-button
            type="primary"
            @click.native="sureAddWaterimg"
          >确定</el-button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import Sortable from 'sortablejs'
export default {
  name: 'adjustArticlePicture',
  data () {
    return {
      visible: false,
      listImg: [],
      fit: 'contain',
      alt: '图片加载失败',
    }
  },
  mounted () {
    this.$root.eventHub.$on('adjustOrderPicModel', (imgList) => {
      this.visible = true
      this.listImg = imgList
      this.$nextTick(() => {
        this.rowDrop()
      })
    })


  },
  destroyed () {
    this.$root.eventHub.$off('adjustOrderPicModel')
  },
  components: {

  },
  computed: {

  },
  methods: {
    rowDrop () {
      var that = this
      var sortable1 = new Sortable(document.querySelector('.watermark_right'), {
        sort: true,
        animation: 300,
        handle: ".each_listcontent_img",
        onEnd: function (evt) {  //拖拽结束发生该事件
          that.listImg.splice(evt.newIndex, 0, that.listImg.splice(evt.oldIndex, 1)[0])
          var newArray = that.listImg.slice(0)
          that.listImg = []
          that.$nextTick(function () {
            that.listImg = newArray
            console.log(that.listImg)
          })
        }
      })
    },
    closeBox () {
      this.visible = false
    },
    sureAddWaterimg () {
      this.$root.eventHub.$emit('adjustOrderArticlePictureSure', this.listImg)
      this.visible = false
    },
    previewCurrentImg (item) {
      this.$root.eventHub.$emit('previewPictureModel', item)
    }
  },
  watch: {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.headimg_box
  .headimg
    position relative
    width 800px
    height 700px
    border-radius 6px
    background #fff
    .title
      clear both
      box-sizing border-box
      padding 0 14px 0 14px
      height 48px
      border-bottom 1px solid #E4E7ED
      .title_name
        span-medium-title()
        float left
        line-height 48px
      .iconfont
        float right
        font-size 22px
        line-height 48px
        cursor pointer
    .watermark
      display flex
      height calc(100% - 48px)
      .watermark_right
        clear both
        height 90%
        overflow auto
        .each_listcontent_img
          float left
          margin-bottom 20px
          margin-left 20px
          width 120px
          height 120px
          cursor pointer
          position relative
          &:hover
            .preview_img
              display flex
          .preview_img
            width 100%
            height 100%
            position absolute
            left 0
            top 0
            background rgba(0, 0, 0, 0.5)
            display none
            justify-content center
            align-items center
            span
              color #fff
              font-size 22px
    .headimg_buttom
      position absolute
      bottom 20px
      display flex
      justify-content flex-end
      box-sizing border-box
      padding-right 20px
      width 100%
      border-radius 0 0 6px 6px
      button
        width 74px
        height 28px
        center()
        line-height 0
</style>
